module.exports = __webpack_public_path__ + "media/images/emblems/Weggis_LU-f0846655bc9197d38b1097330b0d8f1f.png";